import { createContext } from 'react';

import { IGeladaProject, IGeladaOrganisation } from '@netfront/gelada-identity-library';

export interface ICachingEntitiesContext {
  cmsBaseUrl: string | undefined;
  organisation: IGeladaOrganisation | undefined;
  project: IGeladaProject | undefined;
}

export const CachingEntitiesContext = createContext<ICachingEntitiesContext>({
  cmsBaseUrl: undefined,
  organisation: undefined,
  project: undefined,
});

// eslint-disable-next-line import/no-default-export
export default CachingEntitiesContext;
